export { AppErrorBoundary, type ErrorBoundaryScope } from "./AppErrorBoundary";
export type { ScrubRule, SanitizerOptions } from "./beforeSend";
export { createSanitizer } from "./beforeSend";
export { installClickTelemetry, MASK_ATTRIBUTE } from "./clickTelemetry";
export { createTelemetryCaches, type TelemetryCachesOptions } from "./queryTelemetry";
export { reactRootErrorHandlers } from "./reactErrorHandlers";
export { useRouteTelemetry, type RouteTelemetryOptions } from "./routeTelemetry";
export { redactUrl, scrub } from "./scrub";
export {
  getErrorId,
  getSupportId,
  getTelemetryRoute,
  getTelemetrySessionId,
  initTelemetry,
  isTelemetryEnabled,
  reportError,
  setTelemetryAttributes,
  setTelemetryRoute,
  setTelemetryUser,
  startUserAction,
  trackApiFailure,
  trackEvent,
  type ReportErrorOptions,
  type TelemetryAttributes,
  type TelemetryConfig,
} from "./telemetry";
export type { CoreTelemetryEvents, TelemetryAttributeValue } from "./telemetryEvents";

/** Spread onto a control so pressing it starts a Faro user action that links the work it triggers. */
export const userAction = <Name extends string>(name: Name) => ({ "data-faro-user-action-name": name });
